import config from 'customer-flows/config/environment'
import Logger from 'customer-flows/utils/logger'

export default function application({ stores }: CommandArgs) {
  const applicationStore: ApplicationStore = stores['application']

  /**
   * GDPR ip-request
   */
  async function fetchRegionComplianceData() {
    try {
      const ipFetchRequest = fetch(`${config.apiServer}/ip-requests`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      const response = await ipFetchRequest
      const ipFetchRequestData = await response.json()
      applicationStore.regionData = ipFetchRequestData?.data?.attributes
    } catch (e) {
      Logger.error('Failed to fetch region compliance data', { error: e })
    }
  }

  function setPartnerKey(partnerKey: string) {
    applicationStore.partnerKey = partnerKey
  }

  function startLoading() {
    applicationStore.loadingCount++
  }

  function stopLoading() {
    applicationStore.loadingCount = Math.max(applicationStore.loadingCount - 1, 0)
  }

  return {
    fetchRegionComplianceData,
    setPartnerKey,
    startLoading,
    stopLoading
  }
}

declare global {
  export type ApplicationCommands = ReturnType<typeof application>

  // Add to global scope
  interface CommandRegistry {
    application: ApplicationCommands
  }
}
